<template>
    <div>
      <div class="row">
        <div class="col-12 col-md-3">
          <h5>Phone</h5>
          <p>(631) 734-8267</p>
        </div>
        <div class="col-12 col-md-3 footer-info">
          <h5>Address</h5>
          <p>4805 Depot Ln</p>
          <p>Cutchogue, NY 11935</p>
        </div>
        <div class="col-12 col-md-3 footer-info">
          <h5>Hours</h5>
          <p>Monday: Closed</p>
          <p>Tuesday: 4 PM - 9 PM</p>
          <p>Wednesday: 4 PM - 9 PM</p>
          <p>Thursday: 4 PM - 9 PM</p>
        </div>
        <div class="col-12 col-md-3 spacer">
          <p>Friday: 4 PM - 9 PM</p>
          <p>Saturday: 12 PM - 9 PM</p>
          <p>Sunday: 12 PM - 9 PM</p>
        </div>
      </div>
      <div>
        <p class="right footer-info">&copy; 2024 Red Rooster Bistro</p>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>
.spacer {
  margin-top: 24px;
}

@media only screen and (max-width: 768px) {
  .footer-info {
    margin-top: 20px;
  }

  .spacer {
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue